import React from 'react';
import Footer2Component from '../commons/footer2';
import MenuComponent from '../commons/menu';

import {IndexLink, Link, withRouter} from 'react-router';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class PostPage  extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return (
            <div>
                <div className="advertise_boxs" id={isMobile?"t_j_welcome_mobile":"t_j_welcome"}>
                    <div className={"block-001"}>
                        <Link to="/business"><img className={"img_logo"} src="/static/img/appimg/h_logo.png"/></Link>
                        <Link className="btn_login" to="/signin">Sign in</Link>
                        {isMobile?
                            <MenuComponent />
                            :""
                        }
                    </div>
                    <div className={"block-002"}>
                        {isMobile?<img className={"icon_cc"} src="/static/img/appimg/tl_j_img1_mobile.png"/>:""}
                        <div className={"content"}>
                            <p>&nbsp;</p>
                            <h2>Post internships for FREE*</h2>
                            <p>*Term, conditions, quality standards and usage limits apply.</p>
                            <Link to="/employers/signup">Post a Internship</Link>
                        </div>
                    </div>
                    <div className={"block-003"}>
                        <h2>Post internships directly on Versity</h2>
                        <p>How it works</p>
                        <div className={"content1"}>
                            <div className={"item-02"}>
                                <span>Students search for</span>
                                <span>internships on Versity</span>
                                <img src="/static/img/appimg/ads_icon4.png"/>
                                <span>They enter keywords relevant to</span>
                                <span>their experience and background.</span>
                                <span>&nbsp;</span>
                            </div>
                            <div className={"item-02"}>
                                <span>Internships appear in</span>
                                <span>search results</span>
                                <img src="/static/img/appimg/ads_icon5.png"/>
                                <span>Versity matches the internship</span>
                                <span>description and location to</span>
                                <span>the keywords.</span>
                            </div>
                            <div className={"item-03"}>
                                <span>Students Apply</span>
                                <span>&nbsp;</span>
                                <img src="/static/img/appimg/ads_icon6.png"/>
                                <span>Versity Algorithm matches</span>
                                <span>your internship with student profiles.</span>
                                {isMobile?"":<span>&nbsp;</span>}
                            </div>
                            <p>&nbsp;</p>
                        </div>
                    </div>
                    <div className={"block-004"}>
                        <h2>Students and recent grads from 4,000+ colleges & universities</h2>
                        <div className={"content1"}>
                            <div className={"item-02"}>
                                <img className={"icon_cc"} src="/static/img/appimg/tl_j_img2.png"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}
PostPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(PostPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/post.js
 **/